import { defineStore } from "pinia";

type ModalState = {
  modalName: string;
  active: boolean;
  zIndex: number;
  closeCallback: () => void;
};

export const useModalStore = defineStore("modalStore", {
  state: () => ({
    stack: [] as Array<ModalState>,
  }),
});
